// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"488":"c6dc1d7934492e4a","697":"33d5c4dbc5c79d5c"}[chunkId] + ".js";
};